<template>
  <div>
    <b-icon icon="info-circle" v-b-modal="'modal-' + this.uid"></b-icon>

    <b-modal modal-class="customCompModal" :id="'modal-' + this.uid" hide-footer centered>
      <template #modal-header="{ close }">
        <h5>{{ title }}</h5>
        <b-icon icon="x" @click="close()"></b-icon>
      </template>

      <template>
        <div v-html="content" class="modalContentCustom"></div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["title", "content"]
};
</script>
<style lang="scss">
$purple_color: #9561e2;
$lt_grey_color: #999999;
$str_grey_color: #a9a9a9;
$bg_color: #f5f5f5;
$boxShadow: 0px 3px 6px #00000029;


.customCompModal {
    
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: rgb(0 0 0 / 50%);
    }

    .modal-content {
        box-shadow: $boxShadow;
        background-color: $bg_color;
        border-radius: 33px !important;
        color: $lt_grey_color;
        padding: 15px;

        .modal-body {
            text-align: justify;
        }

        .modal-header {
            border-bottom: none !important;
        }
    }

    .modalContentCustom {
        text-align: justify;
    }
}


.modalContentCustom {
  text-align: justify;
}

.bi-info-circle {
  color: $purple_color;
  font-size: 25px;
  &:focus {
    outline: none;
  }
  &:hover {
    cursor: pointer;
    color: black;

    -webkit-animation: rotate-center 0.6s ease-in-out both;
    animation: rotate-center 0.6s ease-in-out both;
  }

  @-webkit-keyframes rotate-center {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotate-center {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}

.bi-x {
  font-size: 25px;
  color: $str_grey_color;

  &:hover {
    cursor: pointer;
    color: black;
  }
}
</style>
